<template>
  <CCol col="12" xl="12" class="p-0">
    <CCard class="p-0">
      <CCardHeader
        class="d-flex justify-content-between align-items-center bg-secondary"
      >
        <h5 class="text-light m-0 p-0">پیام ها</h5>

        <CRow>
          <CInput
            placeholder="جستجو..."
            class="py-0 px-2 m-0 col-12"
            style="direction: ltr"
            v-model="search"
            :value="search"
            @input="quickSearch(search)"
          >
            <template #prepend>
              <CButton color="info" @click="quickSearch(search)">
                <CIcon name="cil-search" />
              </CButton>
            </template>
          </CInput>
        </CRow>
      </CCardHeader>

      <CCard class="my-2 p-0">
        <CButton
          block
          class="text-right shadow-none card-header"
          @click="showFilter = showFilter === 6 ? false : 6"
        >
          <h5 class="text-primary">فیلتر</h5>
        </CButton>
        <CCollapse :show="showFilter === 6">
          <CCardBody>
            <CRow>
              <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                <label class="typo__label">وضعیت پاسخ پیام</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.state"
                  :options="stateList"
                  :allowEmpty="false"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                ></multiselect>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-4 form-group">
                <label class="typo__label">نوع آلارم</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.alarmType"
                  :options="alarmTypeList"
                  :allowEmpty="false"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                ></multiselect></div
            ></CRow>
            <CRow>
              <date-picker
                placeholder="از تاریخ"
                class="col-sm-12 col-md-6 col-lg-4"
                v-model="info.fromDate"
                :value="info.fromDate"
                @change="alarmHistory()"
              >
              </date-picker>
              <date-picker
                placeholder="تا تاریخ"
                class="col-sm-12 col-md-6 col-lg-4"
                v-model="info.toDate"
                :value="info.toDate"
              >
              </date-picker>
              <v-jstree
                class="my-2"
                :data="structureList"
                show-checkbox
                allow-batch
                whole-row
                noDots
                allow-empty
                @item-click="itemClick"
              ></v-jstree>

              <div
                class="col-sm-12 col-md-6 col-lg-4 form-group"
                v-if="deviceList.length > 0"
              >
                <label class="typo__label">دستگاه ها</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.device"
                  :options="deviceList"
                  :allowEmpty="true"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :multiple="true"
                  @input="updateSensorList()"
                ></multiselect>
              </div>

              <div
                class="col-sm-12 col-md-6 col-lg-4 form-group"
                v-if="sensorList.length > 0"
              >
                <label class="typo__label">سنسور ها</label>
                <multiselect
                  class="needs-validation"
                  v-model="info.sensor"
                  :options="sensorList"
                  :allowEmpty="true"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  placeholder="انتخاب..."
                  label="label"
                  track-by="value"
                  :multiple="true"
                ></multiselect>
              </div>
            </CRow>
            <CRow>
              <CButton
                @click="getMessages()"
                class="mt-4 mb-3 btn-success col-sm-12 col-md-6 col-lg-6"
                ><CIcon
                  name="cil-check-circle"
                  class="text-light align-self-center"
              /></CButton>
              <CButton
                @click="clearSearchItem()"
                class="mt-4 mb-3 btn-danger col-sm-12 col-md-6 col-lg-6"
                ><CIcon
                  name="cil-loop-circular"
                  class="text-light align-self-center"
                />
              </CButton>
            </CRow>
          </CCardBody>
        </CCollapse>
      </CCard>

      <div
        v-for="(item, i) in filteredInfo.length > 0 ? filteredInfo : alarm"
        :key="i"
      >
        <CRow class="m-2 px-2 pt-3 rounded border-danger" >
          <CRow>
            <!-- <h6>اطلاعات فرستنده</h6>
            <hr class="m-2 px-2" /> -->
            <p class="text-dark col">
              <span class="text-secondary">فرستنده:</span> {{ item.userName }}
            </p>
            <p class="text-dark col">
              <span class="text-secondary">تاریخ ارسال:</span>
              {{ item.dateSend }}
            </p>
            <CTextarea
              class="col-sm-12 text-secondary"
              :value="item.referralOrder"
              disabled
            />
          </CRow>

          <CRow>
            <h6 class="mt-2">آلارم مربوطه</h6>
            <hr class="m-2 px-2" />
            <CRow v-if="item.alarmType == 1">
              <p class="text-dark col">
                <span class="text-secondary">دستگاه:</span> {{ item.deviceName }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">سنسور:</span>
                {{ item.sensorBaseName + " " + item.sensorIndex }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">مقدار:</span> {{ item.startValue1 }}
              </p>
            </CRow>

            <CRow v-else-if="item.alarmType == 2">
              <p class="text-dark col">
                <span class="text-secondary">دستگاه:</span> {{ item.deviceName }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">محدودیت مکانی</span>
              </p>
              <p class="text-dark col">
                <CButton
                  @click="
                    showMap(item.startValue1, item.startValue2, item.deviceId)
                  "
                  >مشاهده</CButton
                >
              </p>
            </CRow>
            <CRow v-else-if="item.alarmType == 3">
              <p class="text-dark col">
                <span class="text-secondary">دستگاه:</span> {{ item.deviceName }}
              </p>
              <p class="text-dark col">
                <span class="text-secondary">محدودیت سرعت</span>
              </p>
              <p class="text-dark col">
                <span class="text-secondary">سرعت:</span> {{ item.startValue1 }}
              </p>
              <p class="text-dark col">{{ item.startTime }}</p>
            </CRow>
          </CRow>

          <CTextarea class="col-sm-12 text-secondary" :value="item.description" disabled/>

          <CRow v-if="item.response == null ? false : true">
            <h6 class="mt-2">پاسخ</h6>
            <hr class="m-2 px-2" />
            <p class="text-dark col">
              <span class="text-secondary">زمان پاسخ:</span>
              {{ item.dateView }}
            </p>
            <CTextarea class="col-sm-12 text-secondary" :value="item.response"  disabled/>
          </CRow>

          <CRow class="justify-content-center mt-2">
            <!-- <CButton
              @click="setDeviceSetting('sensor')"
              color="success"
              class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
              ><CIcon name="cil-check-circle" class="mx-1" />اتمام</CButton
            > -->
            <!-- <CButton
              :disabled="item.response == null ? false : true"
              @click="sendResponseToSender(item)"
              color="info"
              class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
              ><CIcon name="cil-user" class="mx-1" />پاسخ</CButton
            >
            <CButton
              :disabled="item.response == null ? true : false"
              @click="deleteResponseNotification(item)"
              color="danger"
              class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
              ><CIcon name="cil-user" class="mx-1" />حذف پاسخ</CButton
            > -->
            <!-- <CButton
              @click="showAlarmMessage(item)"
              color="warning"
              class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
              ><CIcon name="cil-list" class="mx-1" />رهگیری</CButton
            > -->
            <!-- <CButton
                    @click="refreshDeviceSetting('wifi')"
                    color="warning"
                    class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
                    ><CIcon name="cil-loop-circular" class="mx-1" />به
                    روزرسانی</CButton
                  > -->
          </CRow>
        </CRow>
        <!-- <CRow
          class="m-2 px-2 pt-3 rounded"
          style="background-color: #ff5733"
          v-else-if="item.message == 2"
        >
          <CRow>
            <p class="text-white col">
              <span class="text-dark">دستگاه:</span> {{ item.deviceName }}
            </p>
            <p class="text-white col">
              <span class="text-dark">سنسور:</span> {{ item.sensorName }}
            </p>
            <p class="text-white col">
              <span class="text-dark">مقدار:</span> {{ item.sensorValue }}
            </p></CRow
          >

          <CTextarea
            disabled
            class="col-sm-12 text-dark"
            label="متن هشدار"
            type="password"
            required
            value="مقدار سنسور از آستانه بیشینه تجاوز نموده است."
          />

          <p class="text-white text-center">{{ item.dateTime }}</p>
        </CRow> -->
      </div>
    </CCard>
    <!-- ----------------------------------------------------- send alarm to user modal -->
    <CModal title="پاسخ ارجاع آلارم" :show.sync="sendModal" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <CForm class="needs-validation" novalidate>
        <!-- <h5 class="text-primary mb-3">اطلاعات محدودیت</h5>
        <hr /> -->

        <CRow>
          <CTextarea
            class="col-12"
            label="شرح پاسخ"
            required
            rows="5"
            v-model="sendUder.command"
            :value="sendUder.command"
          />
        </CRow>
      </CForm>

      <template #footer>
        <CButton
          @click="sendMessage()"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />ارسال</CButton
        >
        <CButton
          @click="sendModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />بازگشت</CButton
        >
      </template>

      <!-- <template #footer>
        <CButton
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template> -->
    </CModal>

    <!-- ----------------------------------------------------- show alarm message modal -->
    <CModal title="پیام های آلارم" :show.sync="alarmMessageModal" size="xl">
      <CAlert color="warning" closeButton :show.sync="alert">
        {{ alertText }}
      </CAlert>
      <CForm class="needs-validation p-0 m-0" novalidate>
        <!-- <h5 class="text-primary mb-3">اطلاعات محدودیت</h5>
        <hr /> -->

        <CRow
          v-for="(item, i) in alarmMessages"
          :key="i"
          class="p-3 rounded mt-1"
          style="background-color: #4169e1"
        >
          <CRow class="m-1 rounded col" style="background-color: #ff5733">
            <p class="text-white col mt-2">
              <span class="text-dark">فرستنده:</span> {{ item.sender }}
            </p>
            <p class="text-white col mt-2">
              <span class="text-dark"> تاریخ:</span> {{ item.sendDateTime }}
            </p>
            <CTextarea
              class="col-sm-12 text-dark"
              :value="'پیام: ' + item.senderMessage"
            />
          </CRow>

          <CRow class="m-1 rounded col" style="background-color: #e59866">
            <p class="text-white col mt-2">
              <span class="text-dark">گیرنده:</span> {{ item.receiver }}
            </p>
            <p class="text-white col mt-2">
              <span class="text-dark">تاریخ:</span> {{ item.receiverDateTime }}
            </p>
            <CTextarea
              class="col-sm-12 text-dark"
              :value="'پاسخ: ' + item.receiverMessage"
            />
          </CRow>
        </CRow>
      </CForm>

      <template #footer>
        <CButton
          @click="alarmMessageModal = false"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />ارسال</CButton
        >
        <CButton
          @click="alarmMessageModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />بازگشت</CButton
        >
      </template>

      <!-- <template #footer>
        <CButton
          @click="addModal = false"
          color="danger"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-ban" />لغو</CButton
        >
        <CButton
          @click="submitForm"
          color="success"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ modalButtonSubmit }}</CButton
        >
      </template> -->
    </CModal>

    <CModal
      :title="alertModalTitle"
      :color="alertModalColor"
      :show.sync="alertModal"
    >
      {{ alertModalText }}

      <template #footer>
        <CButton
          v-if="alertModalTitle != 'حذف پاسخ'"
          @click="alertModal = false"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
        <CButton
          v-else-if="alertModalTitle == 'حذف پاسخ'"
          @click="alertModal = false; deleteResponse();"
          :color="alertModalColor"
          class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
          ><CIcon name="cil-check-circle" />{{ alertModalButtonText }}</CButton
        >
      </template>
    </CModal>
  </CCol>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import axios from "axios";
import { Values } from "../../commonValues";
import VJstree from "vue-jstree-master"; //rtl

export default {
  components: { datePicker: VuePersianDatetimePicker, VJstree },

  data() {
    return {
      alarmMessages: [
        {
          sender: "ناصر شامی",
          sendDateTime: "1401/02/25 23:25:10",
          senderMessage: "لطفا خطا بررسی شود",
          receiver: "امیرعطا امیرخانی",
          receiverDateTime: "1401/02/26 07:25:10",
          receiverMessage: "خطا رفع شد",
        },
        {
          sender: "ناصر شامی",
          sendDateTime: "1401/02/26 20:25:10",
          senderMessage: "لطفا خطا سرویس بررسی شود",
          receiver: "سعید اسمعیلی",
          receiverDateTime: "1401/02/26 23:25:10",
          receiverMessage: "خطا رفع شد",
        },
      ],

      alert: false,
      alertText: "",

      sendUder: { command: "", user: [] },

      alarmTypeList: [
        { label: "همه", value: 0 },
        { label: "سنسور", value: 1 },
        { label: "محدوده", value: 2 },
        { label: "سرعت", value: 3 },
        { label: "تعمیر و نگهداری", value: 4 },
      ],

      sendModal: false,
      alarmMessageModal: false,
      showFilter: 0,

      structureList: [],
      selectedParent: "",

      alarmTrackingIdToSendMessage: "",

      info: {
        ModelValue: [],
        status: [],
        device: [],
        sensor: [],
        fromDate: "",
        toDate: "",
        state:  { label: "مشاهده نشده", value: false},
        alarmType: { label: "همه", value: 0 },
        organizationId: 0,
      },

      stateList: [
        { label: "مشاهده شده", value: true },
        { label: "مشاهده نشده", value: false},
      ],

      sensorList: [],
      deviceList: [],

      filteredInfo: [],
      alarm: [
        // {
        //   activeAlarmId: 1,
        //   deviceName: "انبار دارویی",
        //   sensorTypeName: "دما",
        //   sensorIndex: 1,
        //   startValue1: 30.7,
        //   startValue2: null,
        //   endValue1: 26.6,
        //   endValue2: null,
        //   alarmTypeName: null,
        //   startTime: "1401/04/08 12:59:34",
        //   endTime: "1401/04/08 16:59:37",
        //   sender: "ناصر شامی",
        //   sendDateTime: "1401/02/25 23:25:10",
        //   senderMessage: "لطفا خطا بررسی شود",
        //   receiverResponseDateTime: "1401/02/26 07:25:10",
        //   receiverResponseMessage: "خطا رفع شد",
        // },
        //  {
        //   activeAlarmId: 1,
        //   deviceName: "2انبار دارویی",
        //   sensorTypeName: "دما",
        //   sensorIndex: 2,
        //   startValue1: 30.7,
        //   startValue2: null,
        //   endValue1: 26.6,
        //   endValue2: null,
        //   alarmTypeName: null,
        //   startTime: "1401/04/08 12:59:34",
        //   endTime: "1401/04/08 16:59:37",
        //   sender: "ناصر شامی",
        //   sendDateTime: "1401/02/25 23:25:10",
        //   senderMessage: "لطفا خطا بررسی شود",
        //   receiverResponseDateTime: null,
        //   receiverResponseMessage: null,
        // },
      ],

      date: "",
      search: "",

      alertModal: false,
      alertModalTitle: "",
      alertModalText: "",
      alertModalButtonText: "",
      alertModalColor: "",
    };
  },

  mounted() {
    // axios.get(Values.serverIp + "Alarm/AlarmsTracking").then((response) => {
    //   console.log(response.data);
    //   this.alarm = response.data;
    //   //if (this.alarm.length > 0) this.sendSeenAlarms();
    //   if (this.alarm.length == 0) {
    //     this.alertModal = true;
    //     this.alertModalTitle = "آلارم";
    //     this.alertModalText = "آلارم فعالی موجود نمی باشد.";
    //     (this.alertModalColor = "info"), (this.alertModalButtonText = "تایید");
    //   }
    // });

    //this.GetOrganizationalStructureTree();
    this.GetOrganizationalStructureTreePerUser();
    this.getMessages();
  },

  methods: {
    getMessages() {
      axios
        .post(Values.serverIp + "alarm/AlarmsTracking", {
          viewState: this.info.state.value,
          fromDate: this.info.fromDate,
          toDate: this.info.toDate,
          organizationId: this.info.organizationId,
          deviceLevelList: this.info.device,
          sensorLevelList: this.info.sensor,
          alarmType: this.info.alarmType.value,
        })
        .then((response) => {
          if (response.status == 200) {
            console.log(response.data);
            this.alarm = response.data;
          }
        })
        .catch((response) => {
          console.log(response);
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              // (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },

    //********************************************************************* get organiztion tree  per user*/
    GetOrganizationalStructureTreePerUser() {
      axios
        .get(
          Values.serverIp +
            "OrganizationalStructure/GetOrganizationalStructureTreeForUser"
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.structureList = response.data;
            this.deviceList = [];
            this.sensorList = [];
            this.info.device = [];
            this.info.sensor = [];
            this.GetUserDeviceAccessPermission(false);
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //****************************************************************** select parrent */
    itemClick(node) {
      this.selectedParent = node.model.id;

      this.deviceList = [];
      this.sensorList = [];
      this.info.device = [];
      this.info.sensor = [];
      this.GetDeviceLevelSelectListForUser(node.model.id);
    },

    //********************************************************************* get organiztion tree  per user*/
    GetUserDeviceAccessPermission(data) {
      axios
        .get(Values.serverIp + "User/GetUserDeviceAccessPermission")
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            if (data == false) {
              if (response.data.organizationId != 0) {
                this.GetDeviceLevelSelectListForUser(
                  response.data.organizationId
                );
              }
            } else {
              this.GetDeviceLevelSelectListForUser(
                response.data.organizationId
              );
            }

            //this.structureList = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //********************************************************************* get device per user*/
    GetDeviceLevelSelectListForUser(data) {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "UserDeviceAccessPermission/GetDeviceLevelSelectListForUser",
          JSON.stringify(data),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.deviceList = response.data;
            // if (whichView == "view") this.viewAction(actionData);
            // else if (whichView == "edit") this.editAction(actionData);
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "2خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },
    //********************************************************************* end alarm to users */
    sendAlarmToUsers(data) {
      this.sendModal = true;
    },

    //********************************************************************* end alarm to users */
    showAlarmMessage(data) {
      this.alarmMessageModal = true;
    },
    //********************************************************************* get organiztion tree */
    GetOrganizationalStructureTree() {
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "OrganizationalStructure/GetOrganizationalStructureTree",
          JSON.stringify(""),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);
            this.structureList = response.data;
          } else {
            // modal unsuccessful edit change
            (this.alertModal = true),
              (this.alertModalTitle = "خطایی رخ داده"),
              (this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید."),
              (this.alertModalColor = "danger"),
              (this.alertModalButtonText = "تایید");
          }
        })
        .catch((response) => {
          if (response.status != 200) {
            // modal unsuccessful edit change
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          }
        });
    },

    //****************************************************************** select parrent */
    // itemClick(node) {
    //   this.selectedParent = node.model.id;
    //   //console.log(this.selectedParent);
    //   this.getDeviceByOrganazionId(node.model.id, 0);
    // },

    //***************************************************************** getDeviceByOrganazionId */
    getDeviceByOrganazionId(data, read, selectedDevice, selectedSensor) {
      this.deviceList = [];
      this.info.device = [];
      this.sensorList = [];
      this.info.sensor = [];
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "UserDeviceAccessPermission/GetDeviceLevelSelectList",
          JSON.stringify(data),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.deviceList = response.data;
            // if (read == 1) {
            //   for (var i = 0; i < this.deviceList.length; i++) {
            //     for (var j = 0; j < selectedDevice.length; j++) {
            //       if (selectedDevice[j] == this.deviceList[i].value)
            //         this.userInfo.device.push(this.deviceList[i]);
            //     }
            //   }

            //   this.updateSensorList(1, selectedSensor);
            // }
          }
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              // (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },
    // ************************************************************** updata Sensor List
    updateSensorList(read, selectedSensor) {
      if (this.info.device.length > 0) {
        this.sensorList = [];
        this.info.sensor = [];
        let temp = [];
        for (var i = 0; i < this.info.device.length; i++) {
          temp.push(this.info.device[i].value);
        }

        axios
          .post(
            Values.serverIp +
              "UserDeviceAccessPermission/GetSensorLevelSelectList",
            {
              organizationId: this.selectedParent,
              deviceIds: temp,
            }
          )
          .then((response) => {
            if (response.status == 200) {
              this.sensorList = response.data;
              if (read == 1) {
                for (var i = 0; i < this.sensorList.length; i++) {
                  for (var j = 0; j < selectedSensor.length; j++) {
                    if (selectedSensor[j] == this.sensorList[i].value)
                      this.userInfo.sensor.push(this.sensorList[i]);
                  }
                }
              }
            }
          })
          .catch((response) => {
            //console.log("in catch");
            if (response.response.status == 403) {
              // do not have permission
              // modal unsuccessful edit change
              (this.alertModal = true),
                // (this.showPage = false),
                (this.alertModalTitle = "عدم مجوز"),
                (this.alertModalText =
                  "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
                (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            } else {
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
              this.alertModalColor = "danger";
              this.alertModalButtonText = "تایید";
            }
          });
      } else {
        this.sensorList = [];
        this.info.sensor = [];
      }
    },
    //*************************************************************** clear filter item */
    clearSearchItem() {
      this.info.device = [];
      this.info.sensor = [];
      this.info.ModelValue = [];
      this.info.status = [];
      this.selectedParent = "";
      this.sensorList = [];
      this.deviceList = [];
      //this.GetOrganizationalStructureTree();
      this.GetOrganizationalStructureTreePerUser();
      this.info.fromDate = "";
      this.info.toDate = "";
      this.info.alarmType = { label: "همه", value: 0 };
      this.info.state =  { label: "مشاهده نشده", value: false};
    },
    // ****************************************************** alarm History
    alarmHistory() {
      //console.log(this.date);
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "Alert/AlertsByDate",
          this.date,

          config
        )
        .then((response) => {
          if (response.status == 200) {
            this.info = response.data;
            if (this.info.length == 0) {
              this.alertModal = true;
              this.alertModalTitle = "آلارم";
              this.alertModalText =
                "برای تاریخ انتخاب شده آلارمی موجود نمی باشد.";
              (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            }
          }
        })
        .catch((response) => {});
    },

    //******************************************************** quick Search*/
    quickSearch(data) {
      if (data.length > 0) {
        this.filteredInfo = this.alarm.filter(function (el) {
          return (
            el.carName.includes(data) ||
            el.carPermissionName.includes(data) ||
            el.dateTime.includes(data)
          );
        });
      } else {
        this.filteredInfo = [];
      }

      //console.log(data.length);
    },
    //******************************************************** send alarms seen */
    sendSeenAlarms() {
      let tempIds = [];
      for (let i = 0; i < this.alarm.length; i++)
        tempIds.push(this.alarm[i].alertId);

      //console.log(tempIds);

      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp + "alert/AlertsSeen",
          {
            alertIdList: tempIds,
          },
          config
        )
        .then((response) => {
          if (response.status == 200) {
            //console.log("seen Alarm");
          }
        })
        .catch((response) => {});
    },

    //*************************************************************** deleteResponse */
    deleteResponseNotification(data) {
      (this.alertModal = true),
        (this.alertModalTitle = "حذف پاسخ"),
        (this.alertModalText = "آیا از حذف پاسخ مطمئن هستید؟"),
        (this.alertModalColor = "warning"),
        (this.alertModalButtonText = "بله"),
        (this.alarmTrackingIdToSendMessage = data.alarmTrackingId);
    },

    deleteResponse(){
      const config = { headers: { "Content-Type": "application/json" } };
      axios
        .post(
          Values.serverIp +
            "alarm/DeleteAlarmsTrackingAsync",
          JSON.stringify(this.alarmTrackingIdToSendMessage),
          config
        )
        .then((response) => {
          if (response.status == 200) {
            if(response.data==0)
            {
               this.alertModal = true;
            this.alertModalTitle = "عملیات موفق";
            this.alertModalText =
              "حذف پاسخ با موفقیت انجام شد.";
            this.alertModalColor = "success";
            this.alertModalButtonText = "تایید";
            }
             else{
               this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "پاسخ قابل حذف نیست.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
             }
          
          }
        })
        .catch((response) => {
          //console.log("in catch");
          if (response.response.status == 403) {
            // do not have permission
            // modal unsuccessful edit change
            (this.alertModal = true),
              // (this.showPage = false),
              (this.alertModalTitle = "عدم مجوز"),
              (this.alertModalText =
                "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
              (this.alertModalColor = "info"),
              (this.alertModalButtonText = "تایید");
          } else {
            this.alertModal = true;
            this.alertModalTitle = "خطایی رخ داده";
            this.alertModalText =
              "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
            this.alertModalColor = "danger";
            this.alertModalButtonText = "تایید";
          }
        });
    },

    //********************************************************************* end alarm to users */
    sendResponseToSender(data) {
      this.sendModal = true;
      this.alarmTrackingIdToSendMessage = data.alarmTrackingId;
      this.sendUder.command = "";
    },

    //************************************************************* send message */
    sendMessage() {
      if (this.sendUder.command.length < 1) {
        this.alert = true;
        this.alertText = "لطفا تمامی موارد را وارد نمایید.";
      } else {
        axios
          .post(Values.serverIp + "Alarm/UpdateAlarmsTrackingAsync", {
            alarmTrackingId: this.alarmTrackingIdToSendMessage,
            response: this.sendUder.command,
          })
          .then((response) => {
           // console.log(response);
            if (response.status == 200) {
              // (this.showPage = false),
              if (response.data == 0) {
                (this.sendModal = false),
                  ((this.alertModal = true),
                  (this.alertModalTitle = "ارسال پیام")),
                  (this.alertModalText = "پیام با موفقیت ارسال شد."),
                  (this.alertModalColor = "info"),
                  (this.alertModalButtonText = "تایید");
              } else {
                (this.alertModal = true),
                  (this.alertModalTitle = "ارسال پیام"),
                  (this.alertModalText =
                    "خطا در ارسال پیام!!! لطفا مجدا تلاش فرمایید."),
                  (this.alertModalColor = "danger"),
                  (this.alertModalButtonText = "تایید");
              }
            }
          })
          .catch((response) => {
            //console.log("in catch");
            if (response.status == 403) {
              // do not have permission
              // modal unsuccessful edit change
              (this.alertModal = true),
                // (this.showPage = false),
                (this.alertModalTitle = "عدم مجوز"),
                (this.alertModalText =
                  "شما دارای مجوز دسترسی به این قسمت نمی باشید."),
                (this.alertModalColor = "info"),
                (this.alertModalButtonText = "تایید");
            } else {
              this.alertModal = true;
              this.alertModalTitle = "خطایی رخ داده";
              this.alertModalText =
                "هنگام دریافت اطلاعات خطایی رخ داده. لطفا دوباره امتحان کنید.";
              this.alertModalColor = "danger";
              this.alertModalButtonText = "تایید";
            }
          });
      }
    },
  },
};
</script>

<style>
</style>